
export default {
	name: "NYTStrandsAccordionSection",
	props: {
		headerTitle: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			expanded: false,
		};
	},
};
